import {useContext} from 'react'
import {DarkModeContext, IDarkModeContext} from '../context'

export function useDarkMode(): IDarkModeContext {
  const state = useContext(DarkModeContext)
  return state
}
